import { useEffect } from "react";
import config from "utilities/config";

// Add to this to test workitems. The empty guid on local will return mock data.
const urls = [
  "set-appointment/00000000-0000-0000-0000-000000000000/sms/auto",
  "set-appointment-v2/00000000-0000-0000-0000-000000000000/sms/auto",
  "inspector-badge/0",
];

const LandingPage = () => {
  useEffect(() => {
    if (config.env === "prod") window.location.href = "https://www2.muellerreports.com/";
  }, []);

  if (config.env === "prod") return null;

  return <>{urls.map(url => <p><a key={url} href={url}>{url}</a></p>)}</>;
};

export default LandingPage;